<template>
  <div class="device-settings">
    <div class="form-item form-item--label-top">
      <label class="form-label">{{ str('devices.applianceType') }}</label>
      <select type="text" v-model="applianceType" @change="changed = true">
        <option
          v-for="(option, index) in applianceTypes"
          :key="index"
          :value="option[0]"
        >
          {{ option[1] }}
        </option>
      </select>
      <div class="form-item-help">
        {{ str('devices.applianceTypeHelpText') }}
      </div>
    </div>
    <div class="form-item form-item--label-top">
      <label class="form-label">{{ str('devices.name') }}</label>
      <input type="text" v-model="name" @input="changed = true" />
    </div>
    <div class="form-item form-item--label-top">
      <label class="form-label">{{ str('devices.description') }}</label>
      <textarea
        type="text"
        v-model="description"
        @input="changed = true"
      ></textarea>
    </div>
    <div class="form-actions">
      <LinkButton
        form="deleteDevice"
        :extra-classes="['button--link device-settings__delete']"
        :text="str('devices.deleteDevice')"
        @click.native="$store.commit('showDeleteDevicePopup', true)"
      />
      <LinkButton
        v-if="changed"
        form="deviceSettings"
        icon-right="Arrow"
        :extra-classes="['button--primary device-settings__save']"
        :text="str('global.save')"
        @click.native="saveChanges()"
      />
    </div>
    <DeleteDevicePopup :device="device" />
  </div>
</template>

<script>
  import DeleteDevicePopup from '@/components/devices/DeleteDevicePopup'
  import LinkButton from '@/components/LinkButton'

  export default {
    name: 'device-manual',
    components: {
      DeleteDevicePopup,
      LinkButton,
    },
    props: {
      device: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        name: false,
        description: false,
        applianceType: '',
        changed: false,
      }
    },
    created() {
      this.name = this.device.name.toString()
      this.description = this.device.description.toString()
      this.applianceType = this.device.appliance_type.toString()
    },
    computed: {
      applianceTypes() {
        return this.$store.getters.applianceTypes
      },
    },
    methods: {
      saveChanges() {
        this.$store.dispatch('updateDevice', {
          deviceId: this.device.id,
          name: this.name,
          description: this.description,
          applianceType: this.applianceType,
        })
        this.changed = false
      },
    },
  }
</script>

<style lang="scss">
  .device-settings {
    .form-item {
      margin-bottom: spacer(1);
    }

    &__delete {
      margin-right: auto;
      padding-left: 0;
      padding-right: 0;
      color: $error-color;

      &:hover,
      &:focus,
      &:active {
        background: none;
        color: $error-color;
        text-decoration: underline;
      }
    }
  }
</style>
